export const LOG_ACTIONS = [
  { value: 'login', label: 'Login', color: 'bg-navy/10 text-navy' },
  { value: 'logout', label: 'Logout', color: 'bg-gray-200 text-gray-600' },
  { value: 'signup', label: 'Sign Up', color: 'bg-gold/20 text-gold-dark' },
  { value: 'profile_completed', label: 'Profile Completed', color: 'bg-success/10 text-success' },
  { value: 'add_student', label: 'Add Student', color: 'bg-success/10 text-success' },
  { value: 'update_student', label: 'Update Student', color: 'bg-warning/10 text-warning-dark' },
  { value: 'delete_student', label: 'Delete Student', color: 'bg-danger/10 text-danger' },
  { value: 'add_payment', label: 'Add Payment', color: 'bg-success/10 text-success' },
  { value: 'update_payment', label: 'Update Payment', color: 'bg-warning/10 text-warning-dark' },
  { value: 'delete_payment', label: 'Delete Payment', color: 'bg-danger/10 text-danger' },
  { value: 'add_project', label: 'Add Project', color: 'bg-success/10 text-success' },
  { value: 'update_project', label: 'Update Project', color: 'bg-warning/10 text-warning-dark' },
  { value: 'delete_project', label: 'Delete Project', color: 'bg-danger/10 text-danger' },
  { value: 'approve_officer', label: 'Approve Officer', color: 'bg-success/10 text-success' },
  { value: 'reject_officer', label: 'Reject Officer', color: 'bg-danger/10 text-danger' },
];

export const LOG_ACTIONS_MAP = Object.fromEntries(LOG_ACTIONS.map((a) => [a.value, a]));
